import { PocTypography } from 'commons/components/components-wrapper/poc-typography.component';
import { SettingsViewContent, TitleWithOptions } from 'modules/settings/settings.style';
import { PropsWithChildren } from 'react';
import {
    SettingsFullWidthContentLayoutActionsWrapper,
    SettingsFullWidthContentLayoutModuleScrollable,
    SettingsFullWidthContentLayoutSettingsViewHeader,
    SettingsFullWidthContentLayoutWrapper,
    SettingsViewHeaderDescription,
} from './settings-fullwidth-content-layout.style';

interface SettingsFullWidthContentLayoutProps extends PropsWithChildren {
    title?: string;
    description?: string;
    actionsContent?: React.ReactNode;
    scrollContainerRef?: React.RefObject<HTMLDivElement>;
    extraContent?: React.ReactNode;
}

export const SettingsFullWidthContentLayout: React.FC<SettingsFullWidthContentLayoutProps> = ({
    title,
    description,
    actionsContent,
    scrollContainerRef,
    children,
    extraContent,
}) => (
    <SettingsFullWidthContentLayoutWrapper>
        <SettingsFullWidthContentLayoutModuleScrollable ref={scrollContainerRef}>
            {title || description ? (
                <SettingsFullWidthContentLayoutSettingsViewHeader>
                    <TitleWithOptions>
                        {title ? (
                            <PocTypography element="h5" variant="title5" data-testid="settings-fullwidth-content-title">
                                {title}
                            </PocTypography>
                        ) : null}
                        {actionsContent ? (
                            <SettingsFullWidthContentLayoutActionsWrapper>
                                {actionsContent}
                            </SettingsFullWidthContentLayoutActionsWrapper>
                        ) : null}
                    </TitleWithOptions>
                    {description ? (
                        <SettingsViewHeaderDescription
                            element="p"
                            variant="body1"
                            data-testid="settings-fullwidth-content-description"
                        >
                            {description}
                        </SettingsViewHeaderDescription>
                    ) : null}
                </SettingsFullWidthContentLayoutSettingsViewHeader>
            ) : null}
            <SettingsViewContent>{children}</SettingsViewContent>
        </SettingsFullWidthContentLayoutModuleScrollable>
        {extraContent}
    </SettingsFullWidthContentLayoutWrapper>
);
